import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup} from "@angular/forms";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-phone-verify-modal',
  templateUrl: './phone-verify-modal.component.html',
  styleUrls: ['./phone-verify-modal.component.scss']
})
export class PhoneVerifyModalComponent implements OnInit {

  loading = false;
  constructor(private toastrService: ToastrService,
              public dialogRef: MatDialogRef<PhoneVerifyModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { id: string, countryCode: string, mobile: string }) {
  }

  ngOnInit(): void {
  }

  public confirm(code: string) {
    this.dialogRef.close(
      {
        id: this.data.id,
        code: code
      }
    );
  }

  public pasteError(errPrefix: string, event: string) {
    this.toastrService.error(errPrefix + event);
  }
}
